import type { AdvertisementBrickAdVariant } from '../AdvertisementBrick';
import { AdSlotConfig } from '../../../../app-kit/components/DefineAdSlot/DefineAdSlot';

export const tabletAdWidth = 600;
export const tabletAdHeight = 312;

export const ForSaleAdSlot: AdSlotConfig = {
  path: '/281894996/pca/sale/details/brick',
  size: [[tabletAdWidth, tabletAdHeight]],
  id: 'div-gpt-ad-1723075363442-0',
};

export const ForRentAdSlot: AdSlotConfig = {
  path: '/281894996/pca/rent/details/brick',
  size: [[tabletAdWidth, tabletAdHeight]],
  id: 'div-gpt-ad-1723422941835-0',
};

export const SoldAdSlot: AdSlotConfig = {
  path: '/281894996/pca/sold/details/brick',
  size: [[tabletAdWidth, tabletAdHeight]],
  id: 'div-gpt-ad-1723423116995-0',
};

export const OffMarketAdSlot: AdSlotConfig = {
  path: '/281894996/pca/offmarket/details/brick',
  size: [[tabletAdWidth, tabletAdHeight]],
  id: 'div-gpt-ad-1723423334261-0',
};

export const mapTabletSlotConfigFromVariant = (
  variant: AdvertisementBrickAdVariant,
): AdSlotConfig => {
  switch (variant) {
    case 'FOR_SALE':
      return ForSaleAdSlot;
    case 'FOR_RENT':
      return ForRentAdSlot;
    case 'OFF_MARKET':
      return OffMarketAdSlot;
    case 'SOLD':
      return SoldAdSlot;
  }
};
